import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const OnlineBehaviour = lazy(() => import('../OnlineBehaviour'));

const onlineBehaviourRoute: RouteObject = {
  path: '/online-behaviour',
  element: <OnlineBehaviour />,
};

export default onlineBehaviourRoute;
